// @ts-nocheck
import { transitionStyles } from "@toolkit/Themes/common/mixins";

export const transitionHoverStyles = (...properties: string[]) => {
    return transitionStyles("short", "ease-out", properties);
};

export const transitionControlStyles = (...properties: string[]) => {
    return transitionStyles("regular", "ease-out", properties);
};

export const transitionAnimationStyles = (...properties: string[]) => {
    return transitionStyles("long", "ease-in-out", properties);
};
